import { lastTitle, setToolbarTitle } from '../to-native';

const handlerName = 'GetToolbarTitle';

function handler() {
  setToolbarTitle(lastTitle);
}

export { handlerName, handler };
